import { Box, Tab } from '@mui/material';
import { useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useIntl } from 'react-intl';
import ImportConfiguration from 'pages/importExportConfiguration/components/importConfiguration';
import ExportConfiguration from 'pages/importExportConfiguration/components/exportConfiguration';
import MDBox from 'components/MDBox';

export default function ImportExportConfiguration() {
  const { formatMessage: msg } = useIntl();

  const [selectedTab, setSelectedTab] = useState('1');

  const handleTabChange = (event, newTab) => {
    setSelectedTab(newTab);
  };

  return (
    <MDBox
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
      }}
    >
      <TabContext value={selectedTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            onChange={handleTabChange}
            aria-label="importConfiguration menu"
            sx={{ background: 'white' }}
          >
            <Tab
              label={msg({ id: 'page.tab.importConfiguration.title' })}
              value="1"
              sx={{ background: 'white', fontWeight: 'bold' }}
            />
            <Tab
              label={msg({ id: 'page.tab.exportConfiguration.title' })}
              value="2"
              sx={{ background: 'white', fontWeight: 'bold' }}
            />
          </TabList>
        </Box>
        <TabPanel value="1" sx={{ height: '100%' }}>
          <ImportConfiguration />
        </TabPanel>
        <TabPanel value="2" sx={{ height: '100%' }}>
          <ExportConfiguration />
        </TabPanel>
      </TabContext>
    </MDBox>
  );
}
